import * as gtag from './services/gtag';

let gaEventCounter = 0;
let gaTrackerCount = 1;
let gaClientSessionEventLimit = 450;

const isProduction = process.env.NODE_ENV === 'production';
let lastPageTitle: string;

const {
  initialize: gtagInit,
  exception,
  event,
  eCommerce,
  pageAndScreenView,
} = gtag;

function initialize(
  extraTrackers: Parameters<typeof gtagInit>[0],
  disable: boolean,
) {
  if (extraTrackers.length > 1) {
    gaTrackerCount = extraTrackers.length;
    gaClientSessionEventLimit = gaClientSessionEventLimit / gaTrackerCount;
  }

  gtagInit(extraTrackers, disable);
  // fix 'Event hits must be sent after a pageview hit, but this event hit was not preceded by a pageview'
  lastPageTitle = lastPageTitle || getTitleFromRoute(window.location.hash);
  pageAndScreenView(lastPageTitle);
}

export { eCommerce, event, exception, initialize };

//#region FB
interface FacebookSettings {
  appId: string;
  xfbml: boolean;
  version: string;
}
interface Facebook {
  AppEvents: {
    // Log an application event, for example when someone completes your tutorial.
    logEvent: (
      eventName: string,
      valueToSum?: number,
      parameters?: object,
    ) => void;

    // When someone makes a purchase in your app, log the event.
    // Currnecy: http://en.wikipedia.org/wiki/ISO_4217
    logPurchase: (
      purchaseAmount: number,
      currency: string,
      parameters?: object,
    ) => void;
  };
  init: (settings: FacebookSettings) => void;
}

const FB_SETTINGS: FacebookSettings = {
  appId: '',
  xfbml: true,
  version: 'v2.8',
};

window['fbAsyncInit'] = () => {
  if (window['FB'] && FB_SETTINGS.appId) {
    (window['FB'] as Facebook).init(FB_SETTINGS);
  }
};

export const InitFacebook = (appId: string) => {
  // console.log('Initializing facebook connect with app-id ', appId);
  FB_SETTINGS.appId = appId;

  const fjs = document.getElementsByTagName('script')[0];
  const id = 'facebook-jssdk';

  if (!document.getElementById(id)) {
    const js = document.createElement('script');
    js.id = id;
    js.src = 'https://connect.facebook.net/en_US/sdk.js';
    fjs.parentNode && fjs.parentNode.insertBefore(js, fjs);
  }
};

//#endregion

const TITLE_ROUTE_CONFIG: Array<{ title: string; route: RegExp }> = [
  { title: 'Map Screen', route: /^#\/where/ },
  { title: 'Confirm Address Screen', route: /^#\/delivery\/confirm/ },
  {
    title: 'Delivery/Collection Restaurants List',
    route: /^#\/(collection|delivery)\//,
  },
  { title: 'Phone Number Screen', route: /^#\/phone/ },
  {
    title: 'Restaurant Menu Options Screen',
    route: /^#\/restaurant\/.*\/configure\/[0-9]*\/0$/,
  },
  {
    title: 'Restaurant Menu Screen',
    route: /^#\/restaurant\//,
  },
  { title: 'SMS Code Screen', route: /^#\/code\// },
  { title: 'Payments Screen', route: /^#\/payment\// },
  { title: 'Add New Card Screen', route: /^#\/card\// },
  { title: 'Checkout Screen', route: /^#\/checkout\// },
  { title: 'Add Voucher Screen', route: /^#\/voucher\// },
  { title: 'Order Placed Screen', route: /^#\/order\// },
];
function getTitleFromRoute(hashRoute: string) {
  try {
    const { title } = TITLE_ROUTE_CONFIG.find(({ route }) =>
      route.test(hashRoute),
    );
    return title;
  } catch (error) {
    return '';
  }
}

export const PageView = () => {
  const title = getTitleFromRoute(window.location.hash);

  if (lastPageTitle === title || !title) {
    // stops Google Analytics firing twice!
    return;
  }

  lastPageTitle = title;

  gaEventCounter++;
  if (gaEventCounter < gaClientSessionEventLimit) {
    gtag.pageAndScreenView(title);
  }
};

interface TrackProperties {
  [s: string]: string | number | boolean | undefined;
}

export const Track = (
  category: string,
  action: string,
  props: TrackProperties = {},
) => {
  try {
    const isPurchaseEvent = category === 'Orders' && action === 'Place Order';
    if (isPurchaseEvent) {
      gaEventCounter = 0;
    } else {
      gaEventCounter++;
    }

    if (gaEventCounter < gaClientSessionEventLimit) {
      gtag.event(category, action, props);
    }

    if (!isProduction) {
      console.log(
        '[Track] - disabled outside production!',
        category,
        action,
        props,
      );
      return;
    }

    if (window['FB']) {
      (window['FB'] as Facebook)?.AppEvents?.logEvent(action, undefined, props);
    }
  } catch (e) {
    console.error('Error sending event', e);
  }
};
